import React from 'react';
// @ts-ignore
import Config from 'Config';
import StripeContainer from 'components/StripeContainer';

type Props = {
  children: React.ReactNode;
};

export default function CoachingStripeContainer(props: Props) {
  return (
    <StripeContainer apiKey={Config.Environment.COACHING_STRIPE_PUBLISHABLE_KEY}>
      {props.children}
    </StripeContainer>
  );
}
